import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import RideDetailPage from "./pages/RideDetailPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import RankingPage from "./pages/RankingPage";
import RafflePage from "./pages/RafflePage";
import PassportPage from "./pages/PassportPage";

function App() {
  return (
    <div className="App min-h-screen pt-[64px] sm:pt-[72px]">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/ride/:id" element={<RideDetailPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/raffle" element={<RafflePage />} />
          <Route path="/ranking" element={<RankingPage />} />
          <Route path="/passaporte" element={<PassportPage />} />
        </Routes>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#12141D",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#F8FAFC",
              borderRadius: "2px",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
